import {propertyStatusColor}		from "../data/PropertyStatusColor";


const colorProfiles = {
	"owners" :				["get", "color"],
	"status" :				["match", ["get", "status"],...propertyStatusColor.asMapboxStyle()]
};
	
	
class LayerProperties {
	

	
	constructor(context) {
		
		this.scenario = context.tc.scenario;
		this.map = context.tc.draw.map;
		this.du = context.tc.draw;
		this.tc = context.tc;
		this.context = context;
		this.currentTurbine = false;
		this.currentTurbineIdx = false;
		
	}
	
	json(){


		const props = this.scenario && Array.isArray(this.scenario.layers) ? this.scenario.layers.find((l)=>{return l.id == 'properties'}) : {};
		const initialOpacity = isNaN(props?.data?.opacity) ? parseFloat(process.env.REACT_APP_REST_OPACITY) : props.data.opacity;
		
		


		const l = {
			'source': {
				'id': LayerProperties.sourceId,
				'type': 'geojson',
				'data': this.scenario.properties
			},
			'layer': [
				{
					id: LayerProperties.layerId,
					type: "fill",
					source: LayerProperties.sourceId,
					paint: {
						"fill-opacity": ['case',
							['boolean', ['feature-state', 'invisible'], false],0,
							["all", ['boolean', ['feature-state', 'selected'], false], ['boolean', ['feature-state', 'dimmed'], false]],parseFloat(process.env.REACT_APP_DIMM_OPACITY),
							['boolean', ['feature-state', 'selected'], false],parseFloat(process.env.REACT_APP_ACTIVE_OPACITY),
							['boolean', ['feature-state', 'hover'], false],parseFloat(process.env.REACT_APP_ACTIVE_OPACITY),
							['boolean', ['feature-state', 'dimmed'], false],parseFloat(process.env.REACT_APP_DIMM_OPACITY),
							initialOpacity
						],
						"fill-color": colorProfiles[this.map.projectLayer]
					},
					layout:{
						'visibility': this.map.layerStatus[LayerProperties.layerId] ? 'visible' : 'none'
					}
				},
				{
					'id': LayerProperties.layerNumbersId,
					'type': 'symbol',
					'source': LayerProperties.sourceId,
					'layout': {
						'text-field': (this.map.projectLayer == 'owners' ? ['get', 'description'] : ''),
						'text-variable-anchor': ['center'],
						'text-radial-offset': 0.5,
						'text-justify': 'auto',
						'visibility': this.map.layerStatus[LayerProperties.layerNumbersId] ? 'visible' : 'none'
					},
					'paint': {
						'text-color': ['case',
							['boolean', ['feature-state', 'hover'], false],'#ffffff',
							['boolean', ['feature-state', 'selected'], false],'#ffffff',
							'#000000'
						]	
					}
				},
				{
					'id': LayerProperties.layerStatusNumbersId,
					'type': 'symbol',
					'source': LayerProperties.sourceId,
					'layout': {
						'text-field': (this.map.projectLayer == 'status' ? ['get', 'statusDescription'] : ''),
						'text-variable-anchor': ['center'],
						'text-radial-offset': 0.5,
						'text-justify': 'auto',
						'visibility': this.map.layerStatus[LayerProperties.layerStatusNumbersId] ? 'visible' : 'none'
					},
					'paint': {
						'text-color': ['case',
							['boolean', ['feature-state', 'hover'], false],'#000000',
							['boolean', ['feature-state', 'selected'], false],'#000000',
							'#000000'
						]	
					},

				},
				{
					id: LayerProperties.layerStrokeId,
					type: "line",
					source: LayerProperties.sourceId,
					paint: {
						"line-opacity": ['case',
							['boolean', ['feature-state', 'invisible'], false],0,
							["all", ['boolean', ['feature-state', 'selected'], false], ['boolean', ['feature-state', 'dimmed'], false]],parseFloat(process.env.REACT_APP_DIMM_OPACITY),
							['boolean', ['feature-state', 'selected'], false],1,
							['boolean', ['feature-state', 'hover'], false],1,
							['boolean', ['feature-state', 'dimmed'], false],parseFloat(process.env.REACT_APP_DIMM_OPACITY),
							initialOpacity
						],
						'line-color':['case',
							['boolean', ['feature-state', 'hover'], false],['get', 'color'],
							['boolean', ['feature-state', 'selected'], false],['get', 'color'],
							'#000000'
						],
						"line-width": ['case',
							['boolean', ['feature-state', 'hover'], false],parseFloat(process.env.REACT_APP_ACTIVE_LINE_WIDTH),
							['boolean', ['feature-state', 'selected'], false],parseFloat(process.env.REACT_APP_ACTIVE_LINE_WIDTH),
							parseFloat(process.env.REACT_APP_REST_LINE_WIDTH)
						],
					},
					layout:{
						'visibility': this.map.layerStatus[LayerProperties.layerStrokeId] ? 'visible' : 'none'
					}
				}

				
			]
		};
		return l;
	}
	
		
}

LayerProperties.layerId = 'project-geojson-fill';
LayerProperties.sourceId = 'project-geojson';
LayerProperties.layerNumbersId = 'owner-numbers';
LayerProperties.layerStatusNumbersId = 'status-numbers';
LayerProperties.layerStrokeId = 'project-geojson-stroke';


export default LayerProperties;